export const PaycardTransactionStatus = {
  PENDING: "pending",
  RETURNED: "returned",
  REVERSED: "reversed",
  SETTLED: "settled",
} as const;
export type PaycardTransactionStatus =
  (typeof PaycardTransactionStatus)[keyof typeof PaycardTransactionStatus];
